import { ServiceCreationPerkItem } from '../../components/service-creation-perk-item/service-creation-perk-item';

import styles from './service-creation-perk-list.module.scss';

type Props = {
    perks: string[];
    onDelete: (id: number) => void;
};

const ServiceCreationPerkList = ({ perks, onDelete }: Props) => (
    <ul className={styles.list}>
        {perks.map((perk, idx) => (
            <ServiceCreationPerkItem
                key={idx}
                id={idx}
                text={perk}
                onDelete={onDelete}
            />
        ))}
    </ul>
);

export { ServiceCreationPerkList };
